import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./ProductDetailPage.css";
import { baseURl } from "../../config";
import ProductSlider from "./ProductSlider";
import { fetchRelaPro } from "../util";
import { setRelatedProducts } from "../../store/slice";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const decodeHTML = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const ProductDetails = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { id } = useParams();
  const passedProduct = state?.product;
  const [product, setProduct] = useState(null);
  const { products } = useSelector((state) => state.data);

  useEffect(() => {
    let productIdToSearch = passedProduct?._id || id;

    if (!productIdToSearch) {
      productIdToSearch = localStorage.getItem("selectedProductId");
    }

    if (!productIdToSearch) return;

    const fetchProductDetails = async () => {
      try {
        const categories = products.categories || [];
        let foundProduct = null;

        categories.forEach((category) => {
          if (category.products) {
            category.products.forEach((prod) => {
              if (prod._id === productIdToSearch) {
                foundProduct = prod;
              }
            });
          }

          category.subCat.forEach((subCategory) => {
            subCategory.products.forEach((prod) => {
              if (prod._id === productIdToSearch) {
                foundProduct = prod;
              }
            });
          });
        });

        if (foundProduct) {
          setProduct(foundProduct);
          dispatch(
            setRelatedProducts(
              fetchRelaPro(
                products,
                foundProduct.categorySlug,
                foundProduct.subCategorySlug ? foundProduct.subCategorySlug : "gd",
                foundProduct.productSlug
              )
            )
          );
          localStorage.setItem("selectedProductId", productIdToSearch);
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };

    fetchProductDetails();
  }, [id, passedProduct, products]);

  return (
    <React.Fragment>
      <div className="modern-product-page">
        <div className="modern-product-card">
          <div className="modern-product-image">
            {product ? (
              <img src={`${baseURl}/${product.productImage}`} alt={product.prodName} />
            ) : (
              <Skeleton height={300} width="100%" />
            )}
          </div>

          <div className="modern-product-info">
            <h1 className="modern-product-title">
              {product ? product.prodName : <Skeleton width={200} height={30} />}
            </h1>
            <div className="modern-product-description">
              {product ? (
                <div dangerouslySetInnerHTML={{ __html: decodeHTML(product.productDescription) }} />
              ) : (
                <Skeleton count={5} />
              )}
            </div>
          </div>
        </div>
      </div>

      {product ? <ProductSlider product={product} /> : <Skeleton height={200} width="100%" />}
    </React.Fragment>
  );
};

export default ProductDetails;